var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appie-loader"},[_c('img',{staticClass:"mobile_video",attrs:{"src":require("@/assets/nithra_loading.gif"),"alt":"loading"}})])
}]

export { render, staticRenderFns }